import LANG from "../i18n/loader";
import URI from "./Uri.js";

const Navigation = new class {
    updateURL(url) {
        window.location = URI.getPrefix() + url;
    }

    getPageItemsForNavigation() {
        return [
            {
                "sort": 1,
                "class": "dashboard bg-orange",
                ...LANG.navigation.dashboard.dashboard,
            },
            {
                "sort": 3,
                "class": "industries bg-orange",
                ...LANG.navigation.dashboard.industry,
            },
            {
                "sort": 4,
                "class": "screener bg-orange",
                ...LANG.navigation.dashboard.screener,
            },
            {
                "sort": 2,
                "class": "market bg-orange",
                ...LANG.navigation.dashboard.market,
            },
            {
                "sort": 5,
                "class": "quality bg-orange",
                ...LANG.navigation.dashboard.quality,
            },
        ]
    }

    getPageItemsForSidebar() {
        return [
            {
                "sort": 1,
                "class": "dashboard",
                "link": "/",
                "icon": "home",
                ...LANG.navigation.dashboard.dashboard,
            },
            {
                "sort": 3,
                "class": "industries",
                "link": "/industries",
                "icon": "sector-analysis",
                ...LANG.navigation.dashboard.industry,
            },
            {
                "sort": 4,
                "class": "screener",
                "link": "/screener",
                "icon": "screener",
                ...LANG.navigation.dashboard.screener,
            },
            {
                "sort": 2,
                "class": "market",
                "link": "market",
                "icon": "market-analysis",
                ...LANG.navigation.dashboard.market,
            },
            {
                "sort": 5,
                "class": "quality",
                "link": "/quality",
                "icon": "check",
                ...LANG.navigation.dashboard.quality,
            },
            {
                "sort": 6,
                "class": "profile",
                "link": "/profile",
                "icon": "profile",
                ...LANG.navigation.dashboard.profile,
            },
        ]
    }
}

export default Navigation